import { z } from 'zod';
export const UuidSchema = z.string().uuid();
export const IsoDateTimeSchema = z.string().datetime({ offset: true });
// Para campos de SAÍDA `@db.Date`: o Prisma os serializa como datetime ISO
// ("2024-06-01T00:00:00.000Z"). Aceita date-only ou datetime e normaliza para
// "YYYY-MM-DD" — evita que a validação do SDK quebre listagens. (Para ENTRADA
// use o strict DateOnlySchema de licencias.ts — pitfall de rollover P-010/11.)
export const DateLikeSchema = z.preprocess((v) => (typeof v === 'string' && v.length > 10 ? v.slice(0, 10) : v), z.string().date());
// O backend devolve "" (string vazia) para email/url opcionais não preenchidos.
// z.string().email()/.url() rejeitam "", o que faz o parse da LISTA inteira quebrar
// no SDK (all-or-nothing) → listagens vazias. Estes helpers tratam "" como null e
// validam o formato só quando há valor.
export const NullableEmailSchema = z.preprocess((v) => (v === '' ? null : v), z.string().email().nullable());
export const NullableUrlSchema = z.preprocess((v) => (v === '' ? null : v), z.string().url().nullable());
export const RoleSchema = z.enum(['Superadministrador', 'Administrador', 'Operador', 'Cliente']);
export const EstadoSchema = z.enum(['activo', 'inactivo', 'suspendido']);
export const ModuleCodeSchema = z.enum([
    'dashboard',
    'suscripciones',
    'presupuestos',
    'rrhh',
    'guardias_sucursal',
    'registro_jornal',
    'inventario',
    'licencias',
    'clientes',
    'flota',
    'sucursales',
    'finanzas',
    'recibos-pago',
    'facturacion',
    'cobranzas',
    'auditoria',
    'usuarios',
    'roles_admin',
]);
export const PaginationSchema = z.object({
    page: z.coerce.number().int().positive().default(1),
    pageSize: z.coerce.number().int().positive().max(100).default(20),
});
export const DecimalLikeSchema = z.union([
    z.number().finite(),
    z.string().regex(/^-?\d+(\.\d+)?$/, 'invalid_decimal'),
]);
export const ApiErrorSchema = z.object({
    statusCode: z.number().int(),
    error: z.string(),
    message: z.string(),
    details: z.unknown().optional(),
});
//# sourceMappingURL=common.js.map